import { create } from 'zustand';
import { _cardSizeDelta, _cardSizeMultiplier, _cardSizeMultiplierMax, _cardSizeMultiplierMin, _clipboardCards, _homeNodePath, _lang, _parentMode, _previousPath, _storageVersion, _topSentences, _updateAppTimer } from '../constants';
import { persist, subscribeWithSelector } from 'zustand/middleware';
import { customStorage, load, store } from '../foo';
import { logMe } from '../../foo/user';
import { useURLStore } from './URLZustand';
import { fetchStories } from '../../foo/stories';
import { useGlobalStore } from './globalZustand';

interface StoriesState {
    listOfStories: {[key: string]: any};
    getListOfStories: (lang:string) => {[key: string]: any};
    lastUpdateTimestamp: number;
};

const defaultStoriesState: StoriesState = {
    listOfStories: {},
    getListOfStories: (lang:string) => ({}),
    lastUpdateTimestamp: 0

};

/**
 * Basic typescript usage doesn't require anything
 * special except for writing create<State>()(...)
 * instead of create(...)
**/
export const useStoriesStore = create<StoriesState>()(
    subscribeWithSelector( 
        persist(
        (set,get) => ({
            ...defaultStoriesState,
            getListOfStories: async (lang:string) => {
                // if last update was more than 30 min ago,
                // update listOfStories through fetchStories
                // otherwise, return the current listOfStories
                let listOfStories = get().listOfStories;
                // 30 min = 1800000 ms
                if (Date.now() - get().lastUpdateTimestamp > 1800000) {
                    listOfStories = await fetchStories(lang);
                    set({ listOfStories: listOfStories, lastUpdateTimestamp: Date.now() });
                }
                return listOfStories;
            }

        
        }),
        {
            name: "storiesState",
            storage: customStorage,
            partialize: (state) => ({
                    listOfStories: state.listOfStories,
                    lastUpdateTimestamp: state.lastUpdateTimestamp
            }) 
        }
        )
    )
);


